import cx from 'classnames'

import styles from './TabsContainer.module.scss'

function TabsContainer({ children, className }) {
  return <ul className={cx(styles['container'], className)}>{children}</ul>
}

export default TabsContainer
